













































import debounce from 'lodash/debounce';
import AiStreamCalendar from './components/AiStreamCalendar.vue';
import { IAiStream, ICalendarRange, IAiStreamCalendarTabData } from './types';
import {
  deleteAiStreamerConfig,
  getAiStreamerCalendarRecords
} from '@/api/CopyStake/AiStreamer';
import { errorToastMessage } from '@/helpers/errorToastMessage';

const CopyStakeAiStreamerEditModal = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAiStreamer/AiStreamers/CopyStakeAiStreamerEditModal.vue'
  );

const ConfirmationDialog = (): Promise<any> =>
  import('@/components/ConfirmationDialog.vue');

export default {
  name: 'AiStreamCalendarTab',
  components: {
    AiStreamCalendar,
    CopyStakeAiStreamerEditModal,
    ConfirmationDialog
  },

  data(): IAiStreamCalendarTabData {
    return {
      loading: {
        list: false,
        deleteConfig: false
      },
      error: null,
      streams: [],
      currentRange: null,
      showEditModal: false,
      showConfirmModal: false,
      selectedItem: undefined,
      confirmModalPayload: {}
    };
  },

  watch: {
    showEditModal(val: boolean): void {
      if (!val) {
        this.selectedItem = undefined;
      }
    }
  },

  created(): void {
    this.loadWeekDebounced = debounce(this.loadWeek, 150);
  },

  beforeDestroy(): void {
    this.loadWeekDebounced.cancel();
  },

  methods: {
    async loadWeek(from: string, to: string): Promise<void> {
      this.loading.list = true;
      this.error = null;

      try {
        this.streams = await getAiStreamerCalendarRecords(from, to);
      } catch (e) {
        this.error = 'Failed to load schedule. Please retry.';
        this.streams = [];
      } finally {
        this.loading.list = false;
      }
    },

    reloadCurrentWeek(): void {
      if (this.currentRange) {
        this.loadWeek(this.currentRange.start, this.currentRange.end);
      }
    },

    retry(): void {
      this.reloadCurrentWeek();
    },

    onRangeChange(range: ICalendarRange): void {
      this.currentRange = range;
      this.loadWeekDebounced(range.start, range.end);
    },

    onSelect(stream: IAiStream): void {
      this.$emit('select', stream);
    },

    handleEdit(stream: IAiStream): void {
      this.selectedItem = {
        ...stream,
        supportedGameIds: stream.supportedGames.map((game) => game.id)
      };
      this.showEditModal = true;
    },

    handleCopy(stream: IAiStream): void {
      this.selectedItem = {
        ...stream,
        startTime: '',
        endTime: '',
        supportedGameIds: stream.supportedGames.map((game) => game.id),
        id: null
      };
      this.showEditModal = true;
    },

    handleDelete(stream: IAiStream): void {
      this.confirmModalPayload = {
        header: 'Delete AI Streamer Config',
        okText: 'Delete',
        handler: () => {
          this.loading.deleteConfig = true;

          deleteAiStreamerConfig(stream.id)
            .then(() => {
              this.$toast.success('Config was successfully deleted');
              this.showConfirmModal = false;

              setTimeout(this.reloadCurrentWeek, 2000);
            })
            .catch(errorToastMessage)
            .finally(() => {
              this.loading.deleteConfig = false;
            });
        },
        icon: 'mdi-alert-octagon',
        disclaimer: `
          <p>
            Are you sure you want to delete AI Streamer config for nickname <strong>${stream.nickname}</strong>?
          </p>
          <p class="text--disabled">You will not be able to recover it.</p>`
      };
      this.showConfirmModal = true;
    }
  }
};
